export function configureSearch() {
    console.log('here');
    const searchContainer = document.getElementById('site-search');
    const searchButton = document.getElementById('search-button');
    const searchCloseButton = searchContainer.querySelector('.close-search');
    const searchField = document.getElementById('query');
    const searchResultsContainer = document.getElementById('search-results');

    searchButton.addEventListener('click', e => {
        e.preventDefault();
        searchContainer.classList.add('active');
        searchResultsContainer.classList.add('active');
        return false;
    });
    searchCloseButton.addEventListener('click', e => {
        e.preventDefault();
        searchContainer.classList.remove('active');
        searchResultsContainer.classList.remove('active');
        return false;
    })

    searchField.addEventListener('input', async e => {
        clearResults();
        if (searchField.value.length > 2) {
            const query = searchField.value;
            await searchPages(query);
            await searchPeople(query);
        }
    });

    const clearResults = function () {
        searchResultsContainer.querySelector('.people-list').innerHTML = '';
        searchResultsContainer.querySelector('#article-search-results').innerHTML = '';
    }

    const searchPeople = async function(query) {
        const response = await fetch(`/api/search/people?query=${query}`);
        var json = await response.json();
        var results = json.map(renderPeopleSearchResult);
        searchResultsContainer.querySelector('.people-list').innerHTML = results.join('\n');
        searchResultsContainer.classList.add('active');
    }

    const searchPages = async function (query) {
        const response = await fetch(`/api/search/pages?query=${query}`);
        var json = await response.json();
        var results = json.map(renderSearchResult);
        searchResultsContainer.querySelector('#article-search-results').innerHTML = results.join('\n');
        searchResultsContainer.classList.add('active');
    };

    const renderPeopleSearchResult = function (searchResult) {
        return `
        <li>
            <span class="avatar">${(searchResult.displayName || '').split(' ').map(name => name[0]).join('').toUpperCase()}</span>
            <div class="person-details">
                <span class="person-name">${searchResult.displayName}</span>
                <span class="person-role">${searchResult.jobTitle || ''}</span>
                <span class="person-department">${searchResult.department || ''}</span>
            </div>
        </li>
                        `;
    };

    const renderSearchResult = function (searchResult) {
        if (searchResult.articleImage) {
            return `
        <li class="article-item">
            <a href="${searchResult.url}">
                <img src="${searchResult.articleImage}" class="article-image" />
                <span>
                    ${searchResult.title}
                </span>
            </a>
        </li>
        `;
        }
        return `
        <li class="article-item">
            <a href="${searchResult.url}">
                <span class="article-image"></span>
                <span>
                    ${searchResult.title}
                </span>
            </a>
        </li>
        `;
    }
}